import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';

import goldstar from '../../../images/user/gold-star.png';

import styles from './ChatSettingsV2.css';


const GoldStar = ({ className, ...rest }) => (
  <span
    {...rest}
    className={classNames([className, styles.goldFeature])}
  >
    <img alt="gold star" src={goldstar} />
    {translate('v2profile.gold.feature')}
  </span>
);

GoldStar.propTypes = { className: PropTypes.string };

GoldStar.defaultProps = { className: undefined };

export default GoldStar;
